export default "__VITE_ASSET__q7M_oJYd__"